import React from 'react';

const AppIcon = ({ size = 24, className = "", circleColor }) => {
  const fillColor = circleColor || 'var(--theme-primary)';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Baseball diamond background */}
      <circle cx="12" cy="12" r="10" fill={fillColor} />
      
      {/* Baseball diamond shape */}
      <path
        d="M12 2L22 12L12 22L2 12L12 2Z"
        stroke="white"
        strokeWidth="1.5"
        fill="none"
      />
      
      {/* Home plate */}
      <path
        d="M12 18L10 16L12 14L14 16L12 18Z"
        fill="white"
      />
      
      {/* Base paths */}
      <path
        d="M12 2L12 6M22 12L18 12M12 22L12 18M2 12L6 12"
        stroke="white"
        strokeWidth="1"
      />
      
      {/* Bases */}
      <circle cx="12" cy="6" r="1" fill="white" />
      <circle cx="18" cy="12" r="1" fill="white" />
      <circle cx="12" cy="18" r="1" fill="white" />
      <circle cx="6" cy="12" r="1" fill="white" />
    </svg>
  );
};

export default AppIcon;
